var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jt-doughnut-chart',{attrs:{"centralTitleConst":"DASHBOARD_CONSUMER_UNIT","data":_vm.doughnutData,"shouldShowLegend":true,"shouldShowLabelParts":false,"shouldShowValueInLabelParts":false,"shouldShowPercentageInLabelParts":true}})}
var staticRenderFns = []

export { render, staticRenderFns }